










































import Vue from 'vue'
import { MASS } from '@/mass/models/Mass';
import customerVuex from '../../../customer/vuex/common';
import massVuex from '../../vuex/common';
import AdminVerifyBox from '../common/AdminVerifyBox.vue';
import moment from 'moment';

export default Vue.extend({
  mixins: [customerVuex, massVuex],
  components: {
    AdminVerifyBox,
  },
  props: {
    expectCount: Number,
  },
  data() {
    return {
      dayList: [{value: 1, label: '今天'}, {value: 2, label: '明天'}],
      showAdminVerifyBox: false,
      scheduleAt: null,
      timingDay: 1,
      isTiming: false,
      timingTime: null,
      sendType: MASS.SEND_TYPE.TEMPLATE,
    }
  },
  methods: {
    adminConfirm(data: any) {
      this.$emit('confirm-create', {
        data,
        isTiming: this.isTiming,
        scheduleAt: this.scheduleAt,
      })
    },
    updateTimingTime(val: string) {
      this.timingTime = val;
    },
    startValidateMsg() {
      this.$emit('start-validate')
    },
    confirmMassSend() {
      const isPaidUser = this.accountState.crmLevel && !this.accountState.isExpired;
      const isTrial = this.accountState.isTrial && !isPaidUser;
      if(this.expectCount > 1000 && isTrial) {
        this.$Message.warning('试用期间最多可群发1000人');
      } else if (this.isTiming) {
        if (!this.timingTime) {
          this.$Message.warning('请先设置时间');
        } else if (this.timingTime) {
          let day = null;
          if (this.timingDay === 1) {
            day = moment();
          } else {
            day = moment().add(1, 'days');
          }
          const dayText = day.format('YYYY-MM-DD');
          this.scheduleAt = moment(dayText + ' ' + this.timingTime);
          if (moment().add(5, 'minutes').isAfter(this.scheduleAt)) {
            this.$Message.warning('定时任务至少在当前时间的5分钟后');
          } else {
            this.showAdminVerifyBox = true;
          }
        }
      } else {
        this.showAdminVerifyBox = true;
      }
    },
    changeSendType(isTiming: boolean) {
      this.isTiming = isTiming;
    },
  },
})
